export const styles = {
  calendarContainer: { my: 4 },
  desktopView: { display: { xs: 'none', sm: 'block' } },
  mobileView: { display: { xs: 'block', sm: 'none' } },
  calendarHeader: { padding: '1.5rem', borderRadius: '0.75rem' },
  monthTitle: {
    mb: 2,
    color: 'white',
    fontWeight: '700',
    textAlign: 'center'
  },
  weekDaysContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 14.28%)',
    gap: "0.5rem",
    textAlign: 'center'
  },
  weekDay: {
    color: 'rgb(196, 181, 253)',
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem'
  },
  daysGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 14.28%)',
    gap: "0.5rem",
    textAlign: 'center'
  },
  emptyDay: {
    padding: '0.5rem',
    minHeight: '8rem'
  },
  dayContainer: {
    padding: '0.5rem',
    border: '1px solid rgb(55, 65, 81)',
    borderRadius: '0.5rem',
    minHeight: '8rem'
  },
  dayNumber: {
    fontSize: '0.875rem',
    lineHeight: '1.25rem'
  },
  eventTile: {
    backgroundColor: 'rgba(76, 29, 149, 0.2)',
    borderRadius: '0.25rem',
    padding: '0.25rem',
    marginTop: '0.5rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(76, 29, 149, 0.4)'
    }
  },
  eventName: {
    fontSize: '0.75rem',
    color: 'white'
  },
  mobileList: {
    bgcolor: 'background.paper',
    borderRadius: '0.75rem',
    p: 0
  },

  mobileListItem: {
    borderBottom: '1px solid rgb(55, 65, 81)',
    py: 1.5,
    px: 2,
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  mobileTitle: {
    mb: 2,
    color: 'white',
    fontWeight: '700'
  },
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: '700px' },
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 3,
    borderRadius: '0.75rem',
    outline: 'none',
    maxHeight: '90vh',
    overflowY: 'auto'
  },
  modalTitle: {
    mb: 2,
    color: 'white',
    fontWeight: '700'
  },
  modalText: {
    color: 'white',
    mb: 2
  },
  moreInfoButton: {
    backgroundColor: 'rgb(220, 38, 38)',
    color: 'white',
    '&:hover': {
      backgroundColor: 'rgb(200, 30, 30)'
    }
  },
  navButton: {
    color: 'white',
    '&:hover': {
      backgroundColor: 'rgba(76, 29, 149, 0.4)',
    },
  },
  eventTile: {
    backgroundColor: 'rgba(76, 29, 149, 0.2)',
    borderRadius: '0.25rem',
    padding: '0.25rem',
    marginTop: '0.5rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(76, 29, 149, 0.4)'
    },
    overflow: 'hidden'
  },

  eventName: {
    fontSize: '0.75rem',
    color: 'white',
    fontWeight: '500',
    lineHeight: '1.2'
  },

  organizerName: {
    fontSize: '0.65rem',
    color: 'rgb(196, 181, 253)',
    lineHeight: '1.2',
    fontStyle: 'italic'
  },

  mobileListItem: {
    borderBottom: '1px solid rgb(55, 65, 81)',
    py: 1.5,
    px: 2,
    '&:last-child': {
      borderBottom: 'none'
    },
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(76, 29, 149, 0.1)'
    },
    transition: 'background-color 0.2s'
  },
};